import { createSlice } from "@reduxjs/toolkit";
import { userNormalLogout, supportLogout } from "../actions";

interface Props {
  data: any
}

const initialState: Props = {
  data: {}
}

export const RequestHeaderSlice = createSlice({
  name: "reuqestHeader",
  initialState,
  reducers: {
    saveRequestHeaderData: (state, action) => {
      state.data = action.payload
    },
    resetRequestHeaderData: (state) => {
      state.data = {}
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(userNormalLogout, () => initialState)
      .addCase(supportLogout, () => initialState);
  },
});

export const {
  saveRequestHeaderData,
  resetRequestHeaderData,
} = RequestHeaderSlice.actions;

export default RequestHeaderSlice.reducer;
